module.exports = __webpack_public_path__ + "img/outter-cub.9cae882e.jpg";